import React, { useState } from 'react'

import SharePostDialog from './SharePostDialog'

import { postUrl } from 'lib/postUrl'
import { GlobalIntroJsStyles } from 'core/GlobalIntroJsStyles'
import { WelcomeToPostButton } from 'posts/WelcomeToPostButton'
import { UsersOnlineButton } from 'queues/UsersOnlineButton'
import { IconButton, Tooltip, useTheme } from '@material-ui/core'

import styled from 'styled-components'
import { NotificationsButton } from 'queues/NotificationsButton'

import { 
  PostVotingIcon, PostsOverflow,
  ShareIcon,
} from 'lib-core'


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.25em;
  padding-right: 0.25em;
  && .MuiIconButton-root, && .MuiToggleButton-root {
    padding: 6px;
  }
`

const ViewPostPageExtraNav = (props) => {
  const [sharing, setSharing] = useState<boolean>()
  const theme = useTheme()

  const { post, domainName } = props
  if (!post) {
    return null
  }

  const url = post?.author?.username &&
    postUrl({ domainName, userName: post.author.username, postId: post.name })

  return (
    <Wrapper>
      <GlobalIntroJsStyles />
      <PostVotingIcon color={theme.palette.secondary.main} />
      <PostsOverflow />
      <NotificationsButton />

      <UsersOnlineButton />
      <WelcomeToPostButton />

      <Tooltip title="Share Post" aria-label="Share Post">
        <IconButton
          aria-label="share" color="inherit"
          onClick={() => setSharing(true)}>
          <ShareIcon />
        </IconButton>
      </Tooltip>
      <SharePostDialog
        hidden={!sharing}
        url={url}
        post={post}
        onClose={() => setSharing(false)} author={undefined} />
    </Wrapper>
  )
}

export default ViewPostPageExtraNav
